import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { AwardFileUpload as AwardFileUploadForm } from 'containers/forms/awards'
import { apiAwards, apiCodeLists } from 'helpers/decorators/api'
import { meta } from 'helpers/decorators'

@meta({
  title: 'Upload new document'
})
@apiAwards({
  updateFiles: true
})
@apiCodeLists(['activitySections'])
class AwardFileUpload extends Component {
  static propTypes = {
    awards: PropTypes.object.isRequired,
    blobs: PropTypes.object.isRequired,
    codeLists: PropTypes.object.isRequired,
    uploadAwardFiles: PropTypes.func.isRequired
  }

  render() {
    const { awards, codeLists, blobs } = this.props

    return (
      <div className="row">
        <div className="col-xs-5">
          <AwardFileUploadForm
            codeLists={codeLists}
            uploadAwardFiles={this.props.uploadAwardFiles}
            loading={awards.loading || blobs.loading}
          />
        </div>
      </div>
    )
  }
}

export default AwardFileUpload
